var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"v-application"},[_c('v-main',[_c('navbar'),_c('div',{staticClass:"main-container"},[_c('router-view')],1)],1),(!_vm.hideFooter)?_c('Footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }